import { Select } from "@mantine/core";
import { useEffect, useState } from "react";

import { useQuery } from "@apollo/client";
import { useForm } from "@mantine/form";
import { showNotification } from "@mantine/notifications";
import { GET_ALL_SUPPLIERS } from "apollo/queries";

export default function SupplierFilter({
  setActivePage,
  onCardClick,
  user,
  userValue,
  isSme = false,
}) {
  const [dropDownData, setDropDownData] = useState([]);

  const { refetch } = useQuery(GET_ALL_SUPPLIERS, {
    variables: {
      first: parseInt(2000),
      page: 1,
      search: "",
      is_sme: isSme,
      ordered_by: [
        {
          column: "CREATED_AT",
          order: "DESC",
        },
      ],
    },
    onCompleted(data) {
      const arr = data.getSuppliers.data.map((item) => ({
        label: item.user.name,
        value: userValue ? item.user.id : item.id,
      }));
      setDropDownData(arr);
    },
    onError(error) {
      showNotification({
        color: "red",
        title: "Error",
        message:
          error?.graphQLErrors?.[0]?.message || "Failed to Get Suppliers",
      });
    },
  });

  const form = useForm({
    initialValues: {
      user: null,
    },
  });

  useEffect(() => {
    refetch();
  }, [refetch]);

  const handleUserSelect = (value) => {
    form.setFieldValue("user", value);
    if (setActivePage) {
      setActivePage(1);
    }
    if (onCardClick) {
      if (value === null || value === undefined) {
        onCardClick(null);
      } else {
        const selectedItem = dropDownData.find((item) => item.value === value);
        onCardClick(
          selectedItem ? { value: value, label: selectedItem.label } : null,
        );
      }
    }
  };

  const selectValue = form.values.user || user?.value;

  return (
    <Select
      placeholder="Filter By Supplier"
      data={dropDownData}
      style={{ width: "250px" }}
      value={selectValue}
      onChange={(value) => {
        handleUserSelect(value);
      }}
      onClear={() => handleUserSelect(null)}
      clearable
      searchable
      withinPortal
    />
  );
}
